import { ChangeDetectionStrategy, Component, HostBinding, Input, input } from '@angular/core';

import { CrmConfig, EpcotConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';

import { ITextTruncate } from '../../../../../../lib/common/text-truncate.component';
import { TokenFilter } from '../../../../../../lib/tokens-base/token-base.models';
import { TokenCategories } from '../../../services/reward-tokens-banner.service';

@Component({
    selector: 'bs-reward-token-categories',
    templateUrl: './reward-token-categories.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./reward-token-categories.component.scss'],
    standalone: false,
})
export class RewardTokenCategoriesComponent {
    @HostBinding('class') className = 'reward-token-card__categories';
    @HostBinding('class.reward-drawer__category') get formCoupon(): boolean {
        return this.isRewardDrawerEnabled;
    }

    categories = input.required({ transform: (value: TokenCategories) => Object.values(value) });
    @Input() isRewardDrawerEnabled: boolean;
    @Input() betType: string;
    @Input() tokenFilter: TokenFilter;

    isEpcotEnabled = this.epcotConfig.isEnabled;
    textTruncationConfig: ITextTruncate;

    constructor(
        private epcotConfig: EpcotConfig,
        private crmConfig: CrmConfig,
        private sitecore: Sitecore,
    ) {
        this.textTruncationConfig = this.getConfig();
    }

    get optionCategoryIndex(): number {
        return this.tokenFilter?.options?.length ? Object.keys(this.categories).length - 1 : -1;
    }

    private getConfig(): ITextTruncate {
        return {
            toggleTextTruncate: this.crmConfig.tokens.isTextTruncationEnabled,
            maxLineCount: 2,
            truncationText: this.sitecore.globalMessages.TextTruncation,
        };
    }
}
